import { HotelsList } from '@/components/hotels';
import { hotelCrudConfig, type Hotel } from '@/config/objects/hotels';
import { useNeighborhoodContext } from '@/pages/neighborhoods/useNeighborhoodContext';
import { useApiClient, type CrudConfig } from '@startupquickstart/frontend';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from '@startupquickstart/frontend';

export function NeighborhoodHotelsTab() {
  const { id } = useParams<{ id: string }>();
  const apiClient = useApiClient();
  const { neighborhood } = useNeighborhoodContext();

  const config: CrudConfig<Hotel> = useMemo(
    () => ({
      ...hotelCrudConfig,
      entityName: 'Hotel',
      entityNamePlural: 'Hotels',
      endpoints: {
        ...hotelCrudConfig.endpoints,
        list: `/neighborhoods/${id}/hotels`,
        delete: (hotelId: string) => `/neighborhoods/${id}/hotels/${hotelId}`,
      },
      listView: {
        ...hotelCrudConfig.listView,
        actions: {
          add: {
            enabled: true,
            endpoint: '/hotels',
            where: neighborhood?.greaterAreaId
              ? {
                  greaterAreaId: neighborhood.greaterAreaId,
                  neighborhoodId: {
                    not: neighborhood.id,
                  },
                }
              : neighborhood
                ? {
                    neighborhoodId: {
                      not: neighborhood.id,
                    },
                  }
                : undefined,
            onAdd: async (hotel: Hotel) => {
              await apiClient.post(`/neighborhoods/${id}/hotels`, { hotelId: hotel.id });
              toast.success('Hotel added to neighborhood');
            },
          },
          view: {
            enabled: true,
          },
          remove: {
            enabled: true,
            onRemove: async (hotel: Hotel) => {
              await apiClient.delete(`/neighborhoods/${id}/hotels/${hotel.id}`);
              toast.success('Hotel removed from neighborhood');
            },
          },
        },
      },
    }),
    [neighborhood, id, apiClient],
  );

  if (!id) return null;

  return <HotelsList config={config} className="p-0" baseUrl="/hotels" />;
}
